<header class="relative z-50 flex h-[64px] flex-shrink-0 items-center gap-3 px-4 max-[760px]:gap-1 max-[760px]:px-2 nf-surface nf-shadow-bar rounded-none border-b border-sk-border">

  <!-- Feature name -->
  <div class="flex flex-1 items-center gap-2 min-w-0">
    <sk-icon [name]="featureIcon()" size="md" class="text-primary flex-shrink-0" />
    <span class="text-base font-medium text-sk-text truncate">{{ featureName() }}</span>
    @if (featureId()) {
      <button type="button" data-sk-tour="topbar-favorite" (click)="toggleFavorite()"
        [class]="'flex-shrink-0 transition-colors hover:opacity-80 ' + (isFavorite() ? 'text-[var(--sk-color-warning-500)]' : 'text-sk-text-secondary')">
        <sk-icon name="star" size="sm" />
      </button>
    }
  </div>

  <!-- Right actions -->
  <div class="flex items-center gap-2 flex-shrink-0">

    <button
      type="button"
      data-sk-tour="topbar-search"
      class="nf-surface flex min-w-0 items-center justify-between gap-3 px-3 py-2 text-sm text-sk-text-secondary border border-sk-border rounded-lg transition-colors hover:border-sk-border-strong hover:text-sk-text max-[760px]:px-2"
      (click)="openSearch.emit()"
      [attr.aria-label]="'layout.topbar.openSearch' | transloco">
      <span class="flex items-center gap-2">
        <sk-icon name="search" size="sm" />
        <span class="max-[760px]:sr-only">{{ 'layout.topbar.searchTools' | transloco }}</span>
      </span>
      <kbd class="nf-inset rounded-full px-2 py-0.5 text-xs max-[760px]:hidden">Ctrl K</kbd>
    </button>

    <!-- Cluster selector -->
    <nf-cluster-selector data-sk-tour="topbar-cluster" />

    <!-- Notifications -->
    <div class="relative" data-notifications-bell>
      <sk-button variant="ghost" size="md" (skClick)="openNotifs.emit()" [attr.aria-label]="'layout.topbar.notifications' | transloco">
        <sk-icon name="bell" size="md" />
      </sk-button>
      @if (unreadCount() > 0) {
        <sk-badge
          class="absolute -top-0.5 -right-0.5 pointer-events-none text-xs"
          variant="danger">
          {{ unreadCount() > 9 ? '9+' : unreadCount() }}
        </sk-badge>
      }
    </div>

    <!-- Halloween mode (offered during the season) -->
    @if (halloween.available()) {
      <sk-button
        variant="ghost"
        size="md"
        (skClick)="halloween.toggle()"
        [attr.aria-pressed]="halloween.enabled()"
        [attr.aria-label]="(halloween.enabled() ? 'layout.topbar.halloweenOff' : 'layout.topbar.halloweenOn') | transloco"
        [attr.title]="(halloween.enabled() ? 'layout.topbar.halloweenOff' : 'layout.topbar.halloweenOn') | transloco">
        <span class="text-lg leading-none" [class.opacity-40]="!halloween.enabled()" aria-hidden="true">🎃</span>
      </sk-button>
    }

    <!-- Theme toggle -->
    <sk-button
      data-sk-tour="topbar-theme"
      variant="ghost"
      size="md"
      (skClick)="toggleTheme.emit()"
      [attr.aria-label]="(isDarkMode() ? 'layout.topbar.switchToLight' : 'layout.topbar.switchToDark') | transloco">
      <sk-icon [name]="isDarkMode() ? 'sun' : 'moon'" size="md" />
    </sk-button>

  </div>
</header>
